module.exports = __webpack_public_path__ + "img/Assistance.03c335ab.svg";